import { css } from 'emotion';
import chroma from 'chroma-js';
import { animationTransition } from '@joykit/variables';

export namespace styles {
  export const container = css({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  });

  const exploreButtonHover = chroma('#999')
    .darken(0.6)
    .css();

  export const exploreIssueButton = css({
    color: '#999999',
    transition: animationTransition('color'),
    ':hover': {
      color: exploreButtonHover
    }
  });

  export const message = css({
    marginRight: '24px',
    color: '#c33f3f'
  });

  export const svgContainer = css({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    ':hover': {
      ' svg g': {
        stroke: '#E8B0B3'
      }
    }
  });

  export const svg = css({
    marginRight: 8,
    ' g': {
      transition: animationTransition('stroke')
    }
  });
}
